const gsap = require('../modules/gsap-utils');
const TweenLite = require('gsap/TweenLite').TweenLite;

require('gsap/EasePack');
require('gsap/CSSPlugin');

/*
 * Mobile Menu
 */
window.onload = function() {

    let $body = document.querySelector('body');
    let $menuButton = document.querySelector('.menuButton');
    let $headerLogo = document.querySelector('header .headerLogo');
    let $loginButton = document.querySelector('.loginButton');

    let $navMenu = document.querySelector('.navBottom');

    let menuDurationIn = 0.4;
    let menuDurationOut = 0.2;
    let menuEase = Power4.easeInOut;

    window.__ = {
        navmenu: $navMenu,
        ease: menuEase,
        duration: menuDurationIn,
        TL: TweenLite
    };

    $menuButton.addEventListener('click', function () {

        //__________ Open the menu __________
        if ($navMenu.classList.contains('closed')) {

            // Change ALL the classes
            $body.classList.add('over-hidden');             // make body not scrollable

            $navMenu.classList.add('open');                 // Add .open to menu
            $navMenu.classList.remove('closed');            // remove .closed from menu

            $menuButton.classList.add('menu-open');         // Add .menu-open to button
            $menuButton.classList.remove('menu-closed');    // remove .menu-closed from button

            $loginButton.classList.add('loginButton--visible');       // add visible class to loginButton
            $headerLogo.classList.add('headerLogo--small');       // Make logo smaller

            // Menu animates in
            TweenLite.fromTo($navMenu, menuDurationIn,
                {
                    ease: menuEase,
                    y:"-100%",
                    display: "block",
                }, {
                    ease: menuEase,
                    y:'0%',
                });

        }

        //__________ Close the menu __________
        else if ($navMenu.classList.contains('open')) {

            // Change ALL the classes
            $body.classList.remove('over-hidden');             // make body scrollable

            $navMenu.classList.remove('open');              // remove .open fromm menu
            $navMenu.classList.add('closed');               // add .closed to menu

            $menuButton.classList.remove('menu-open');      // remove .menu-open from button
            $menuButton.classList.add('menu-closed');       // add .menu-closed to button

            $loginButton.classList.remove('loginButton--visible');

            $headerLogo.classList.remove('headerLogo--small');       // Make logo big again

            // Menu animates out
            TweenLite.to($navMenu, menuDurationOut, {
                y:'-100%',
                ease: menuEase,
                onComplete: gsap.setDisplayNone,
                onCompleteParams: [$navMenu]
            });

        }
    });

};
